import "core-js/modules/es6.regexp.replace";
var rUpper = /([A-Z])/g;
export default function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}